import { render, staticRenderFns } from "./externalProject.vue?vue&type=template&id=d6a236bc&scoped=true&"
import script from "./externalProject.vue?vue&type=script&lang=ts&"
export * from "./externalProject.vue?vue&type=script&lang=ts&"
import style0 from "./externalProject.vue?vue&type=style&index=0&id=d6a236bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a236bc",
  null
  
)

export default component.exports